import React from 'react';
import { connect } from 'react-redux';
import { Route, Redirect } from 'react-router-dom';
import i18next from "i18next";

export const PrivateRoute = ({ component: ComposedComponent, ...rest }) => {
  // redirect if not authenticated; otherwise, return the component input into <PrivateRoute />  
  const AuthenticationContainer = connect(({ auth }) => ({ authenticated: auth.authenticated }))(({ authenticated }) => (
    <Route { ...rest } render={(ccProps) => authenticated ? 
      <ComposedComponent {...ccProps} /> : 
      <Redirect to={{ pathname: '/signin', state: { from: ccProps.location, message: i18next.t('messages.auth-required') } }}/>
    } />
  ));

  return <AuthenticationContainer />;
}
